import { Injectable } from '@angular/core';
import { Category, OrganizerEventPreference } from '../../../models';
import { Event } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class EventTemplatePreferenceServices {
  public eventTemplateOutput: Event;
  public eventModels: {[eventId: number]: Event} = {};
  public eventPreferences: OrganizerEventPreference;

  public generateTemplateOutput(eventPreferences: OrganizerEventPreference) {
    this.eventPreferences = eventPreferences;
    // create an event object with all preferences
    const eventsIdSorted = Object.entries(eventPreferences.eventTemplates)
      .filter( ([k, v]) => !!v)
      .sort( (a, b) => a[1].order - b[1].order)
      .map( ([k,v]) => k);
    if (!eventsIdSorted || eventsIdSorted.length <= 0) {
      this.eventTemplateOutput = null;
      return;
    }
    const templateOption = eventPreferences.eventTemplates;
    const eventsData = this.eventModels;
    this.eventTemplateOutput = new Event({});
    eventsIdSorted.forEach( (eventId) => {
      // automations must be built according to matching event date start
      eventsData[eventId]?.Automations?.forEach((a) => a.eventDateStart = eventsData[eventId]?.dateStart);
      this.eventTemplateOutput = {
        ...this.eventTemplateOutput,
        ...eventsData[eventId],
        id: undefined,
        url: undefined,
        keywords: eventsData[eventId].description, // event description is keywords
        status: undefined,
        modifiedBy: undefined,
        name: undefined,
        dateEnd: undefined,
        Organizers: templateOption[eventId].Organizers ?
          eventsData[eventId].Organizers : this.eventTemplateOutput.Organizers,
        EventPersonalization: templateOption[eventId].EventPersonalization ?
          eventsData[eventId].EventPersonalization : this.eventTemplateOutput.EventPersonalization,
        Categories: templateOption[eventId].Categories ?
          eventsData[eventId].Categories?.map( (c) => this.convertCategory(c)) : this.eventTemplateOutput.Categories,
        CategoriesGroups: undefined,
        TicketingPlatforms: undefined,
        TicketTemplates: templateOption[eventId].TicketTemplates ?
          [ eventsData[eventId].TicketTemplates?.[0] ] : this.eventTemplateOutput.TicketTemplates,
        WaitListConfig: templateOption[eventId].WaitListConfig ?
          eventsData[eventId].WaitListConfig : this.eventTemplateOutput.WaitListConfig,
        Automations: templateOption[eventId].Automations ?
          eventsData[eventId].Automations : this.eventTemplateOutput.Automations,
      };
    });
  }

  public convertCategory(category: Category) {
    return new Category({
      ...category,
      upgradeCategoryId: undefined,
    });
  }

}
